renderAllCardSwatches();

function renderAllCardSwatches(){
  const datahandle = document.querySelectorAll('[data-product-handle]');
  if(!datahandle.length) return;
  datahandle.forEach(async card => {
    const handle = card.dataset.productHandle;
    const leatherOptions = JSON.parse(card.dataset.leatherOptions || "[]");
    const fabricOptions = JSON.parse(card.dataset.fabricOptions || "[]");
    const upholsteryOptions = JSON.parse(card.dataset.upholsteryOptions || "[]");

    if (leatherOptions?.length) {
      await loadCardSwatches(handle, leatherOptions, "leather_option_image");
    } else if (fabricOptions?.length) {
      await loadCardSwatches(handle, fabricOptions, "fabric_option_image");
    } else if (upholsteryOptions?.length){
      await loadCardSwatches(handle, upholsteryOptions,"upholstery_option_image")
    }
  });
}

async function loadCardSwatches(productHandle, variantOptions, metaObjectType) {
  const swatches = await fetchAllSwatches(metaObjectType);
   
  const productCard = document.querySelector(`[data-product-handle="${productHandle}"]`);
  const swatchContainer = productCard?.querySelector('.card_product_Vcolor');
    if (!swatchContainer) return;

  // ✅ Prevent duplicate swatches
  if (swatchContainer.childElementCount > 0) return;
  let displayedCount = 0;
    const totalCount = Array.isArray(variantOptions) ? variantOptions.length : 0;
  for (let opt of variantOptions || []) {
    const handleizedOpt = handleizeString(opt);
    const match = swatches.find(s => handleizeString(s.title) === handleizedOpt);

    if (match && match.imageUrl && (!window.colorSwatchSettings.enableColorLimit || displayedCount < window.colorSwatchSettings.colorMaximum)) {
      const img = document.createElement('img');
      img.src = match.imageUrl;
      img.alt = match.title;
      img.className = 'hdt-rounded-full';
      swatchContainer.appendChild(img);
      displayedCount++;
    }
  }

  if (window.colorSwatchSettings.enableColorLimit && totalCount > window.colorSwatchSettings.colorMaximum) {
    const moreLink = document.createElement('a');
    moreLink.href = productCard.dataset.productUrl;
    moreLink.className = 'show-more-colors';
    moreLink.innerText = `+${totalCount - window.colorSwatchSettings.colorMaximum} More Colours`;
    swatchContainer.appendChild(moreLink);
  }
}

function handleizeString(str) {
  return str
    .toLowerCase()
    .replace(/[\u2013\u2014]/g, "-")
    .replace(/[-!"#$₹%&'* ,./:;<=>?@[\\\]_`{|}~]+/g, "-")
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u")
    .replace(/ß/g, "ss")
    .replace(/[()]+/g, "")
    .replace(/^-+|-+$/g, "");
}

async function fetchAllSwatches(metaObjectType) {
  let allSwatches = [];
  let cursor = null;
  let hasNextPage = true;
  const apiVersion = '2025-01';
  const accessToken = "a0668e7d01480ae5601cbdfda447f425";
  const shopifyStore = Shopify.shop;

  while (hasNextPage) {
    const query = {
      query: `{
        metaobjects(first: 50, type: "${metaObjectType}", after: ${cursor ? `"${cursor}"` : null}) {
          edges {
            node {
              id
              fields {
                key
                value
              }
              imageField: field(key: "image") {
                reference {
                  ... on MediaImage {
                    id
                    image {
                      url
                    }
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`
    };

    const response = await fetch(`https://${shopifyStore}/api/${apiVersion}/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken
      },
      body: JSON.stringify(query)
    });

    const data = await response.json();
    if (data.data?.metaobjects?.edges?.length) {
      const swatches = data.data.metaobjects.edges.map(edge => {
        const fields = edge.node.fields;
        return {
          id: edge.node.id,
          title: fields.find(f => f.key === "title")?.value,
          imageUrl: edge.node.imageField?.reference?.image?.url || "",
        };
      });

      allSwatches = allSwatches.concat(swatches);
      hasNextPage = data.data.metaobjects.pageInfo.hasNextPage;
      cursor = data.data.metaobjects.pageInfo.endCursor;
    } else {
      hasNextPage = false;
    }
  }

  return allSwatches;
}